import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF } from '../../../Layout/tokens';

const PANELS: Record<string, TypedGroupviewPanelState> = {
  orderMonitoring: {
    id: 'orderMonitoring',
    contentComponent: 'orderMonitoring',
    title: 'Orders',
    params: { type: 'orderMonitoring' },
  },
  tradeMonitoring: {
    id: 'tradeMonitoring',
    contentComponent: 'tradeMonitoring',
    title: 'Trades',
    params: { type: 'tradeMonitoring' },
  },
  quoteMonitoring: {
    id: 'quoteMonitoring',
    contentComponent: 'quoteMonitoring',
    title: 'Quotes',
    params: { type: 'quoteMonitoring' },
  },
  executionReportMonitoring: {
    id: 'executionReportMonitoring',
    contentComponent: 'executionReportMonitoring',
    title: 'Execution Reports',
    params: { type: 'executionReportMonitoring' },
  },
};

const GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: BRANCH,
        data: [
          {
            type: LEAF,
            visible: true,
            data: { views: ['orderMonitoring'], activeView: 'orderMonitoring', id: 'orderMonitoring' },
            size: 800,
          },
          {
            type: LEAF,
            visible: true,
            data: { views: ['tradeMonitoring'], activeView: 'tradeMonitoring', id: 'tradeMonitoring' },
            size: 800,
          },
        ],
        size: 450,
      },
      {
        type: BRANCH,
        data: [
          {
            type: LEAF,
            visible: true,
            data: { views: ['quoteMonitoring'], activeView: 'quoteMonitoring', id: 'quoteMonitoring' },
            size: 800,
          },
          {
            type: LEAF,
            visible: true,
            data: {
              views: ['executionReportMonitoring'],
              activeView: 'executionReportMonitoring',
              id: 'executionReportMonitoring',
            },
            size: 800,
          },
        ],
        size: 450,
      },
    ],
    size: 900,
  },
  width: 1600,
  height: 900,
  orientation: Orientation.VERTICAL,
};

export const OMS_GRID_MONITORING_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
